import React from "react";
import {
  useRetrieveCurrentPlanzone,
  useRetrieveProjectReports,
  useRetrieveProjectReportTemplate,
} from "@planzone/view-models";
import { Props } from "./types";
import { ReportsList } from "./reportsList";
import styles from "./styles.scss";
import { useTranslation } from "react-i18next";
import { Loader } from "./loader";

function getIndicatorsNames(
  reports: { fields: { type: string; name: string }[] }[],
): string[] {
  const names = new Set<string>();
  reports.forEach((report) =>
    report.fields
      .filter((f) => f.type === "indicator")
      .forEach((f) => names.add(f.name)),
  );
  return Array.from(names);
}

function Reports({ project }: Props) {
  const { t } = useTranslation();
  const { planzone } = useRetrieveCurrentPlanzone();
  const {
    reports,
    isRequestFailure: isRequestFailure,
    isRequestSuccess: isRequestSuccess,
    isRequestPending: isRequestPending,
    retrieveProjectReports,
  } = useRetrieveProjectReports(project);
  const {
    reportTemplates,
    isRequestPending: isReportTemplateRequestPending,
    isRequestSuccess: isReportTemplateRequestSuccess,
    isRequestFailure: isReportTemplateRequestFailure,
    retrieveProjectReportTemplate,
  } = useRetrieveProjectReportTemplate(planzone);
  const indicatorsNames = getIndicatorsNames(reports);

  React.useEffect(() => {
    !!project.uuid &&
      !isRequestPending &&
      !isRequestFailure &&
      !isRequestSuccess &&
      retrieveProjectReports(project);
  }, [project.uuid, isRequestFailure, isRequestSuccess, isRequestPending]);

  React.useEffect(() => {
    !isReportTemplateRequestPending &&
      !isReportTemplateRequestFailure &&
      !isReportTemplateRequestSuccess &&
      retrieveProjectReportTemplate(planzone);
  }, []);

  return (
    <div className={styles.reports}>
      {isRequestPending ? (
        <Loader />
      ) : (
        <>
          {!reports.length ? (
            <div className={styles.noReports}>
              {t("projectPage.synthesisPage.reports.empty")}
            </div>
          ) : (
            <div className={styles.main}>
              <div className={styles.reportsList}>
                <ReportsList
                  project={project}
                  reports={reports}
                  indicatorsNames={indicatorsNames}
                />
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}

export { Reports };
